import { ROUTER_REDUCER } from './root.constants';
import { createSelector } from 'reselect';

const getRoute = (state: any) => state.get(ROUTER_REDUCER);

export const getLocation = createSelector(getRoute, (route) =>
  route.getIn(['location', 'pathname']),
);
